import { Injectable } from '@angular/core';
declare const amplitude: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsManagerService {

  constructor() { }

  logEvent = function (eventName, eventProperties) {
    if (eventProperties) {
      amplitude.getInstance().logEvent(eventName, eventProperties)
    } else {
      amplitude.getInstance().logEvent(eventName)
    }
  }

  setUserId = function (userId) {
    amplitude.getInstance().setUserId(userId)
  }

  setUserProperties = function (properties) {
    amplitude.getInstance().setUserProperties(properties)
  }

  add = function (eventName, eventProperties) {
    var identify = new amplitude.Identify().add(eventName, eventProperties);
    amplitude.getInstance().identify(identify);
  }

  set = function (eventName, eventProperties) {
    var identify = new amplitude.Identify().set(eventName, eventProperties);
    amplitude.getInstance().identify(identify);
  }

  setOnce = function (eventName, eventProperties) {
    var identify = new amplitude.Identify().setOnce(eventName, eventProperties);
    amplitude.getInstance().identify(identify);
  }

}
